import { Box } from "@mui/material";
import SvgIcon from "@mui/material/SvgIcon";

import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export default function SitemarkIcon() {
  const navigate = useNavigate();
  return (
    <Box sx={{ cursor: "pointer" }}>
      <SvgIcon
        onClick={() => navigate("/")}
        sx={{ height: 36, width: 130, mr: 1 }}
      >
        <svg
          width={130}
          height={36}
          viewBox="0 0 130 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="36" height="36" rx="8" fill="#111827" />
          <path
            d="M8 28 Q18 8 28 28"
            stroke="#66b2ff"
            strokeWidth="2.5"
            fill="none"
            strokeLinecap="round"
          />
          <circle cx="8" cy="28" r="3.5" fill="#4cceac" />
          <circle cx="28" cy="28" r="3.5" fill="#4cceac" />
          <circle cx="18" cy="9" r="3.5" fill="#66b2ff" />

          <text
            x="44"
            y="25"
            fontFamily="'Plus Jakarta Sans', sans-serif"
            fontSize="22"
            fontWeight="700"
            fontStyle="italic"
            fill="#66b2ff"
          >
            Jerny
          </text>
        </svg>
      </SvgIcon>
    </Box>
  );
}
